module.exports = __webpack_public_path__ + "static/cai_sensor_flow-2053f5091ea13336cb69dc1a6627a2af.png";